import { Campaign } from "Types/Campaign";

import { CampaignStatusTag } from "../../../../shared/Components/CampaignStatus/CampaignStatusTag";

export function shortCampaign(campaign: Campaign | Record<string, any>): string | undefined {
    if (!campaign?.name) {
        return "";
    }
    // 30 chars is ideal for drop down display to not get fucked
    const campaignId = ` (#${campaign.friendlyId})`;

    if (campaign?.name?.length + campaignId.length <= 30) {
        return `${campaign.name}${campaignId}`;
    }

    const campaignNameLength = 27 - campaignId.length;
    const shortenedCampaignName = campaign.name.slice(0, campaignNameLength);

    return `${shortenedCampaignName}...${campaignId}`;
}

export function CampaignOptionLabel({
    campaign,
    actionType,
}: {
    campaign: Campaign | Record<string, any>;
    actionType: string;
}): JSX.Element {
    if (campaign) {
        return (
            <span className="flex-row justify-between align-center">
                {shortCampaign(campaign)}
                <CampaignStatusTag state={campaign?.state} />
            </span>
        );
    }

    return <span> {`${actionType} Campaign`}</span>;
}
